/* iter-loom-phone-advisory · Oct-2026.
 *
 * Informational (non-blocking) popup shown once per session when a
 * real mobile PHONE (not a tablet — see `useIsSmallPhone`) opens any
 * "/loom", "/loom/editor", "/app", or "/app/business" surface. The
 * Loom's writing workbench still renders underneath (via the existing
 * pan/zoom `MobileWorkbenchShell` canvas), this just sets expectations
 * that a pad/desktop gives the full feature set.
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MonitorSmartphone } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const SESSION_KEY = 'pw:loom-phone-advisory-seen';

export const SmallPhoneLoomNotice = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(() => {
    try { return sessionStorage.getItem(SESSION_KEY) !== '1'; } catch (_e) { return true; }
  });

  const dismiss = () => {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (_e) { /* noop */ }
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent className="max-w-sm" data-testid="loom-small-phone-advisory">
        <DialogHeader>
          <div className="mb-1 flex h-9 w-9 items-center justify-center rounded-sm bg-amber-100 text-amber-800">
            <MonitorSmartphone className="h-4.5 w-4.5" />
          </div>
          <DialogTitle data-testid="loom-small-phone-advisory-title">{t('loomAdvisory.phoneTitle')}</DialogTitle>
          <DialogDescription data-testid="loom-small-phone-advisory-body">
            {t('loomAdvisory.phoneBody')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={dismiss} className="w-full" data-testid="loom-small-phone-advisory-dismiss">
            {t('loomAdvisory.phoneDismiss')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
